<template>
  <div class="show-form-cars">
    <table class="table">
      <tbody>
        <tr>
          <td class="label-col">Фамилия</td>
          <td>{{ driver.last_name }}</td>
        </tr>
        <tr>
          <td>Имя</td>
          <td>{{ driver.first_name }}</td>
        </tr>
        <tr>
          <td>Отчетво</td>
          <td>{{ driver.middle_name }}</td>
        </tr>
        <tr>
          <td>Телефон</td>
          <td>{{ driver.phone }}</td>
        </tr>
        <tr>
          <td>Адрес проживания</td>
          <td>{{ driver.address }}</td>
        </tr>
      </tbody>
    </table>
    <hr class="mb-4" />
  </div>
</template>

<script>
export default {
  name: 'DriverShowForm',
  props: ['id', 'driver']
}
</script>

<style scoped>
  .show-form-cars {
    margin-top: 4rem;
  }
  .label-col {
    width: 25%;
  }
</style>
